import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/lottery.ts
const LotteryTypes = {
	AprilFoolsDay2025: "aprilFoolsDay2025",
	SpringEvent2025: "springEvent2025",
	AugustEvent2025: "augustEvent2025",
	AnniversaryEvent2025: "anniversaryEvent2025",
	NewYearEvent2026: "newYearEvent2026",
	AprilFoolsEvent2026: "aprilFoolsEvent2026",
	SpringPromotionEvent2026: "springPromotionEvent2026"
};
const lotteryTypeSchema = z.enum(LotteryTypes);
const lotteryRewardStatusEnum = ["LOCKED", "CLAIMED"];
const guaranteeRarityEnum = ["SR", "SSR"];
const springPromotionEvent2026InputSchema = z.object({
	isTenRoll: z.boolean().optional(),
	autoBuy: z.boolean().optional()
}).optional();
const rollInputSchema = z.object({
	lotteryType: lotteryTypeSchema,
	springPromotionEvent2026Input: springPromotionEvent2026InputSchema
});
const springPromoProgressRewardsSchema = z.object({
	p7: z.enum(lotteryRewardStatusEnum),
	p12: z.enum(lotteryRewardStatusEnum),
	p17: z.enum(lotteryRewardStatusEnum),
	p20: z.enum(lotteryRewardStatusEnum),
	p25: z.enum(lotteryRewardStatusEnum)
});
const springPromotionEvent2026StatusSchema = z.object({
	rollCount: z.int(),
	eventTokenCount: z.int(),
	ownedCardCodes: z.array(z.string()),
	srPityCount: z.int(),
	ssrPityCount: z.int(),
	srPityRemaining: z.int(),
	ssrPityRemaining: z.int(),
	uniqueCount: z.int(),
	progressRewardsClaimed: springPromoProgressRewardsSchema,
	dailyFreeClaimAvailable: z.boolean(),
	dailyFreeClaimedToday: z.int().min(0),
	grandGuaranteeRemaining: z.int(),
	hasCollectedAllCards: z.boolean(),
	completedChapterIds: z.array(z.string())
});
const springPromoBoostRewardSchema = z.object({
	percentage: z.int(),
	availableUntil: z.iso.datetime()
});
const aprilFoolsEvent2026RewardSchema = z.object({
	sign: z.string(),
	creditReward: z.int(),
	extraPackageBoostCode: z.string(),
	extraPackageBoostPercentage: z.int(),
	availableSince: z.iso.datetime(),
	availableUntil: z.iso.datetime()
});
const rollOutputSchema = z.object({
	lotteryType: z.string(),
	cardCodes: z.array(z.string()).nullish(),
	isGuarantee: z.boolean().nullish(),
	guaranteeType: z.enum(guaranteeRarityEnum).nullish(),
	aprilFoolsEvent2026Reward: aprilFoolsEvent2026RewardSchema.nullish(),
	springPromotionEvent2026Status: springPromotionEvent2026StatusSchema.nullish(),
	springPromoBoostRewards: z.array(springPromoBoostRewardSchema).nullish()
});
const purchaseTokenInputSchema = z.object({
	lotteryType: lotteryTypeSchema,
	quantity: z.int().optional()
});
const claimRewardInputSchema = z.object({
	lotteryType: lotteryTypeSchema,
	progressCount: z.int().optional()
});
const resetStatusInputSchema = z.object({ lotteryType: lotteryTypeSchema });
const lotteryContract = oc.prefix("/lottery").tag("Lottery").router({
	roll: oc.route({
		method: "POST",
		path: "/roll",
		summary: "Roll lottery for Spring Promotion 2026"
	}).input(rollInputSchema).output(rollOutputSchema),
	purchaseToken: oc.route({
		method: "POST",
		path: "/purchase-token",
		summary: "Purchase lottery tokens"
	}).input(purchaseTokenInputSchema),
	claimReward: oc.route({
		method: "POST",
		path: "/claim-reward",
		summary: "Claim lottery progress reward"
	}).input(claimRewardInputSchema).output(z.enum(lotteryRewardStatusEnum).nullable()),
	reset: oc.route({
		method: "POST",
		path: "/reset",
		summary: "Reset lottery user state (debug/admin)"
	}).input(resetStatusInputSchema)
});
//#endregion
export { LotteryTypes, claimRewardInputSchema, guaranteeRarityEnum, lotteryContract, purchaseTokenInputSchema, resetStatusInputSchema, rollInputSchema, rollOutputSchema };
